import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component
export default class EpicSearchTabNav extends Vue {
    public title: string = 'EpicSearchTabNav';

    @Prop({ default: '60px' })
    public height: any;

    @Prop({ default: '144px' })
    public width: any;

    public eActive: boolean = false;

    @Prop({ default: null })
    public data: any;

    @Prop({ default: null })
    public feature: any;

    public style = {
        'height': this.height,
        'width': this.width,
        'background-color': 'rgba(18, 60, 73, 0.82)',
    };

    public activeStyle = {
        'height': this.height,
        'width': this.width,
        'background-color': 'rgba(237, 28, 36, 0.8)',
    };

    public created() {
    }

    @Watch('data', { immediate: true, deep: true })
    public onDataInput(val: any, oldVal: any) {
    }

    public onClick() {
        // this.eActive = !this.eActive;
        this.$emit('rifo-click');
    }
}
